import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Download from '@/views/Download.vue'
import Search from '@/views/Search.vue'
import JWT from '@/utils/jwt'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/tim-kiem',
      name: 'search',
      component: Search
    },
    {
      path: '/download',
      name: 'download',
      component: Download
    },
    // Auth
    {
      path: '/auth/dang-nhap',
      name: 'auth-login',
      meta: { layout: 'auth', guest: true },
      component: () =>
        import(/* webpackChunkName: "auth-login" */ "@/views/auth/Login"),
    },
    {
      path: '/auth/dang-xuat',
      name: 'auth-logout',
      meta: { layout: 'auth', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "auth-logout" */ "@/views/auth/Logout"),
    },
    {
      path: '/auth/dang-ky',
      name: 'auth-register',
      meta: { layout: 'auth', guest: true },
      component: () =>
        import(/* webpackChunkName: "auth-register" */ "@/views/auth/Register"),
    },
    {
      path: '/auth/forgot-password',
      name: 'auth-forgot-password',
      meta: { layout: 'auth' },
      component: () =>
        import(/* webpackChunkName: "auth-forgot-password" */ "@/views/auth/ForgotPassword"),
    },
    {
      path: '/auth/reset-password',
      name: 'auth-reset-password',
      meta: { layout: 'auth' },
      component: () =>
        import(/* webpackChunkName: "auth-reset-password" */ "@/views/auth/ResetPassword"),
    },
    {
      path: '/auth/mobiedu',
      name: 'auth-mobiedu',
      meta: { layout: 'auth', guest: true },
      component: () =>
        import(/* webpackChunkName: "auth-login" */ "@/views/auth/Mobiedu"),
    },
    {
      path: '/auth/dang-ky-cong-thi-thu',
      name: 'auth-test-portal-regis',
      meta: { layout: 'default', guest: true },
      component: () =>
        import(/* webpackChunkName: "auth-login" */ "@/views/auth/TestPortalRegis"),
    },
    // User
    {
      path: '/nguoi-dung/thong-tin-ca-nhan',
      name: 'user-profile',
      meta: { layout: 'profile', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "user-profile" */ "@/modules/users"),
      props: {
        template: "UserProfile"
      }
    },
    {
      path: '/nguoi-dung/lich-su-thanh-toan',
      name: 'user-activity',
      meta: { layout: 'profile', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "user-activity" */ "@/modules/users"),
      props: {
        template: "UserActivity"
      }
    },
    {
      path: '/nguoi-dung/danh-sach-de-thi',
      name: 'user-exam-list',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "user-exam-list" */ "@/modules/users"),
      props: {
        template: "UserExamList"
      }
    },
    {
      path: '/nguoi-dung/de-thi-da-lam',
      name: 'user-exam-recent',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "user-exam-recent" */ "@/modules/users"),
      props: {
        template: "UserExamRecent"
      }
    },
    {
      path: '/nguoi-dung/nap-tien',
      name: 'user-topup',
      meta: { layout: 'profile', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "user-topup" */ "@/modules/users"),
      props: {
        template: "UserTopup"
      }
    },
    // News
    {
      path: '/tin-tuc',
      name: 'news-list',
      component: () =>
        import(/* webpackChunkName: "news-list" */ "@/modules/news"),
      props: {
        template: "NewsList"
      }
    },
    {
      path: '/tin-tuc/:slug-:id(\\d+).html',
      name: 'news-detail',
      component: () =>
        import(/* webpackChunkName: "news-detail" */ "@/modules/news"),
      props: {
        template: "NewsDetail"
      }
    },
    {
      path: '/tin-tuc/:slug-:id(\\d+)',
      name: 'news-category',
      component: () =>
        import(/* webpackChunkName: "news-category" */ "@/modules/news"),
      props: {
        template: "NewsCategory"
      }
    },
    {
      path: '/noi-dung/:slug',
      name: 'page-detail',
      component: () =>
        import(/* webpackChunkName: "page-detail" */ "@/views/Page")
    },
    // Exams
    {
      path: '/danh-muc-de-thi/:slug-:id(\\d+)',
      name: 'exam-category',
      component: () =>
        import(/* webpackChunkName: "exam-detail" */ "@/modules/exams"),
      props: {
        template: "ExamCategory"
      }
    },
    {
      path: '/de-thi/:slug-:id(\\d+)',
      name: 'exam-detail',
      component: () =>
        import(/* webpackChunkName: "exam-detail" */ "@/modules/exams"),
      props: {
        template: "ExamDetail"
      }
    },
    {
      path: '/mua-de-thi/:slug-:id(\\d+)',
      name: 'exam-purchase',
      meta: { layout: 'profile', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "exam-purchase" */ "@/modules/exams"),
      props: {
        template: "ExamPurchase"
      }
    },
    {
      path: '/xac-nhan-mua-de-thi/:slug-:id(\\d+)',
      name: 'exam-purchase-confirm',
      meta: { layout: 'exam-purchase-confirm', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "exam-purchase-confirm" */ "@/modules/exams"),
      props: {
        template: "ExamPurchaseConfirm"
      }
    },
    {
      path: '/lam-de-thi/:slug-:id(\\d+)',
      name: 'exam-response',
      meta: { layout: 'exam', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "exam-response" */ "@/modules/exams"),
      props: {
        template: "ExamResponse"
      }
    },
    {
      path: '/review-de-thi/:slug-:id(\\d+)',
      name: 'exam-preview',
      meta: { layout: 'exam', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "exam-response" */ "@/modules/exams"),
      props: {
        template: "ExamPreviewResponse"
      }
    },
    {
      path: '/ket-qua-thi/:id(\\d+)',
      name: 'exam-result',
      meta: { layout: 'exam', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "exam-result" */ "@/modules/exams"),
      props: {
        template: "ExamResult"
      }
    },
    {
      path: '/ket-qua-thi-chi-tiet/:id(\\d+)',
      name: 'exam-result-detail',
      meta: { layout: 'exam', requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "exam-result-detail" */ "@/modules/exams"),
      props: {
        template: "ExamResultDetail"
      }
    },
    // Packages
    {
      path: '/goi-cuoc',
      name: 'package-list',
      component: () =>
        import(/* webpackChunkName: "package-list" */ "@/modules/packages"),
      props: {
        template: "PackageList"
      }
    },
    {
      path: '/goi-cuoc/:id(\\d+)',
      name: 'package-purchase',
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "package-purchase" */ "@/modules/packages"),
      props: {
        template: "PackagePurchase"
      }
    },
    {
      path: '/thanh-toan-goi-cuoc/:id(\\d+)',
      name: 'package-payment',
      component: () =>
        import(/* webpackChunkName: "package-payment" */ "@/modules/packages"),
      props: {
        template: "PackagePayment"
      }
    },
    // Classes
    {
      path: '/lop-hoc',
      name: 'class-list',
      component: () =>
        import(/* webpackChunkName: "class-list" */ "@/modules/classes"),
      props: {
        template: "ClassList"
      }
    },
    {
      path: '/lop-hoc/:id(\\d+)-:slug',
      name: 'class-subject',
      component: () =>
        import(/* webpackChunkName: "class-subject" */ "@/modules/classes"),
      props: {
        template: "ClassSubjectDetail"
      }
    },
    {
      path: '/luyen-tap/:id(\\d+)-:slug',
      name: 'class-subject-part',
      component: () =>
        import(/* webpackChunkName: "class-subject-part" */ "@/modules/classes"),
      props: {
        template: "ClassPartDetail"
      }
    },
    {
      path: '/luyen-tap/ket-qua-hoc-tap',
      name: 'class-statistic',
      component: () =>
        import(/* webpackChunkName: "class-statistic" */ "@/modules/classes"),
      props: {
        template: "ClassStatistic"
      }
    },
    {
      path: '/ma-kich-hoat',
      name: 'ma-kich-hoat',
      meta: { layout: 'auth', requiresAuth: true  },
      component: () =>
        import(/* webpackChunkName: "ma-kich-hoat" */ "@/modules/activations"),
    },
    {
      path: '/khao-sat/',
      name: 'khao-sat',
      meta: { layout: 'popup' , componentName: 'roomsComponent' },
      component: () =>
        import(/* webpackChunkName: "thi-thu" */ "@/views/SurveyForm.vue"),
    },
    {
      path: '/thi-thu/',
      name: 'thi-thu',
      meta: { layout: 'testing' , componentName: 'roomsComponent' },
      component: () =>
        import(/* webpackChunkName: "thi-thu" */ "@/modules/rooms"),
    },
    {
      path: '/thi-thu/xep-hang',
      name: 'thi-thu-xep-hang',
      meta: { layout: 'testing' , componentName: 'rankComponent'  },
      component: () =>
        import(/* webpackChunkName: "thi-thu-xep-hang" */ "@/modules/rooms"),
    },
    {
      path: '/thi-thu/lich-su',
      name: 'thi-thu-lich-su',
      meta: { layout: 'testing' , componentName: 'historiesComponent'  },
      component: () =>
        import(/* webpackChunkName: "thi-thu-lich-su" */ "@/modules/rooms"),
    },
    // 404
    // { path: '/404', component: NotFound },
    // { path: '*', redirect: '/404' },
  ]
})

router.beforeEach((to, from, next) => {
  // Kiểm tra nếu có search param ads thì lưu vào localStorage
  if (to.query.ads) {
    localStorage.setItem('ads', to.query.ads);
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user = JWT.getAccessToken()
    if (user) {
      next()
    } else {
      next({
        name: 'auth-login',
        query: { nextUrl: to.fullPath }
      })
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    let user = JWT.getAccessToken()
    if (user) {
      let nextUrl = to.query.nextUrl || to.query.redirect
      if (nextUrl && nextUrl.startsWith('/')) {
        next(nextUrl)
      } else {
        next({ name: 'home' })
      }
    } else {
      next()
    }
  } else {
    next() 
  }
})

export default router;